import { render } from "./form.vue?vue&type=template&id=2ec59eee&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import "./form.vue?vue&type=style&index=0&id=2ec59eee&lang=scss&scoped=true"
import "./form.vue?vue&type=style&index=1&id=2ec59eee&lang=scss"
script.render = render
script.__scopeId = "data-v-2ec59eee"

export default script